import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/app/common/common-components/ui/DropdownMenu";
import { ChevronDown, Mail, MessageCircle, Phone } from "lucide-react";
import HelpLinkIcon from "@/app/common/common-components/HelpLinkIcon";
import { Button } from "@/app/common/common-components/ui/Button";
import { WhatsAppIcon } from "@/app/common/common-components/BrandIcons";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/app/common/common-components/ui/HoverCard";

type NewMessageButtonProps = {
  handleNewMessageClick: (messageType: "Whatsapp" | "SMS" | "Email") => void;
  variant?: "default" | "icons";
  contactPhone?: string;
};

const NewMessageButton = ({
  handleNewMessageClick,
  variant = "default",
  contactPhone,
}: NewMessageButtonProps) => {
  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
      {variant === "default" && (
        <>
          <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
              <Button className="tw-flex tw-w-fit tw-items-center tw-gap-1">
                New Message <ChevronDown className="tw-size-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="start">
              <DropdownMenuGroup>
                <DropdownMenuItem
                  onClick={() => handleNewMessageClick("Whatsapp")}
                >
                  WhatsApp
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => handleNewMessageClick("SMS")}>
                  SMS
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => handleNewMessageClick("Email")}
                >
                  Email
                </DropdownMenuItem>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
          <HelpLinkIcon href="https://help.entegral.net/en/articles/11938690-sending-messages-to-contacts" />
        </>
      )}
      {variant === "icons" && (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
          {contactPhone && (
            <HoverCard>
              <HoverCardTrigger asChild>
                <Button size="icon" asChild>
                  <a href={`tel:${contactPhone.replace(" ", "")}`}>
                    <Phone className="tw-size-4" />
                  </a>
                </Button>
              </HoverCardTrigger>
              <HoverCardContent className="tw-w-fit tw-px-2 tw-py-1 tw-text-xs">
                Call the contact
              </HoverCardContent>
            </HoverCard>
          )}
          <HoverCard>
            <HoverCardTrigger asChild>
              <Button size="icon" onClick={() => handleNewMessageClick("SMS")}>
                <MessageCircle className="tw-size-4" />
              </Button>
            </HoverCardTrigger>
            <HoverCardContent className="tw-w-fit tw-px-2 tw-py-1 tw-text-xs">
              Send an SMS to the contact
            </HoverCardContent>
          </HoverCard>
          <HoverCard>
            <HoverCardTrigger asChild>
              <Button
                size="icon"
                onClick={() => handleNewMessageClick("Email")}
              >
                <Mail className="tw-size-4" />
              </Button>
            </HoverCardTrigger>
            <HoverCardContent className="tw-w-fit tw-px-2 tw-py-1 tw-text-xs">
              Send an email to the contact
            </HoverCardContent>
          </HoverCard>
          <HoverCard>
            <HoverCardTrigger asChild>
              <Button
                size="icon"
                onClick={() => handleNewMessageClick("Whatsapp")}
              >
                <WhatsAppIcon className="tw-size-4 tw-fill-white" />
              </Button>
            </HoverCardTrigger>
            <HoverCardContent className="tw-w-fit tw-px-2 tw-py-1 tw-text-xs">
              Chat on WhatsApp with the contact
            </HoverCardContent>
          </HoverCard>
          <HelpLinkIcon href="https://help.entegral.net/en/articles/11938690-sending-messages-to-contacts" />
        </div>
      )}
    </div>
  );
};

export default NewMessageButton;
